import {
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { TitlesWrapper, StyledFormHelperText } from './styled';
import { useIngredientsLogic } from './useIngredientLogic';
import ImagesContainer from './components/Images';

const IngredientMutation = () => {
  const {
    paramId,
    isLoading,
    methods,
    errors,
    isSuccess,
    isImageViewOpen,
    isButtonLoading,
    imageSrcForAction,
    largeImageMessage,
    setValue,
    setFlowProcess,
    onSubmit,
    register,
    handleSubmit,
    onChangeUpload,
    handleDeleteImage,
  } = useIngredientsLogic();

  if (isLoading) {
    return <div>Loading</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
      >
        <Typography
          variant="h5"
          sx={{ mb: 4 }}
        >
          { paramId ? 'Edit Ingredient' : 'Create New Ingredient'}
        </Typography>

        <TitlesWrapper>
          <TextField
            {...register('name')}
            label="Name"
            error={!!errors.name}
            helperText={errors.name ? 'Name is required' : ''}
          />
        </TitlesWrapper>

        <ImagesContainer
          posibilityToMainImage={false}
          keyUploadedFileList="uploadedFileList"
          keyMainImageUrl="mainImageUrl"
          keyExistingImages="existingImages"
          buttonText="Upload Images"
          setValue={setValue}
          multiple={false}
          handleDeleteImage={handleDeleteImage}
          isImageViewOpen={isImageViewOpen}
          imageSrcForAction={imageSrcForAction}
          setFlowProcess={setFlowProcess}
          onChangeUpload={onChangeUpload}
        />

        {largeImageMessage && <StyledFormHelperText id="messages">{largeImageMessage}</StyledFormHelperText>}
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mt: 1 }}
          disabled={isButtonLoading}
        >
          {paramId ? 'UPDATE' : "CREATE"}
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default IngredientMutation;
